import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "../../lib/api";
import { setSettingsCache } from "../../lib/settingsCache";

export function useSettings() {
  const query = useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await api.get("/settings")).data,
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (query.data) setSettingsCache(query.data);
  }, [query.data]);

  return query;
}
